/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Copy_Success_ToastInputs */

const en_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activation code copied to clipboard successfully.`)
};

const fr_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code d'activation copie dans le presse-papiers avec succes.`)
};

const de_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivierungscode erfolgreich in die Zwischenablage kopiert.`)
};

const it_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice di attivazione copiato correttamente negli appunti.`)
};

const ru_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код активации успешно скопирован в буфер обмена.`)
};

const es_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de activación copiado al portapapeles exitosamente.`)
};

const zh_cn2_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活码已成功复制到剪贴板。`)
};

const ja_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベーション コードがクリップボードに正常にコピーされました。`)
};

const hi_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्टिवेशन कोड सफलतापूर्वक क्लिपबोर्ड पर कॉपी हो गया है।`)
};

const pt_pt2_offline_activation_copy_success_toast = /** @type {(inputs: Offline_Activation_Copy_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de ativação copiado com sucesso para a área de transferência.`)
};

/**
* | output |
* | --- |
* | "Activation code copied to clipboard successfully." |
*
* @param {Offline_Activation_Copy_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_copy_success_toast = /** @type {((inputs?: Offline_Activation_Copy_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Copy_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_copy_success_toast(inputs)
	if (locale === "de") return de_offline_activation_copy_success_toast(inputs)
	if (locale === "it") return it_offline_activation_copy_success_toast(inputs)
	if (locale === "ru") return ru_offline_activation_copy_success_toast(inputs)
	if (locale === "es") return es_offline_activation_copy_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_copy_success_toast(inputs)
	if (locale === "ja") return ja_offline_activation_copy_success_toast(inputs)
	if (locale === "hi") return hi_offline_activation_copy_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_copy_success_toast(inputs)
	return en_offline_activation_copy_success_toast(inputs)
});